import config from './config'
import IndicadoresModules from './ind'
export default [
    {
        path: '/',
        component: () => import("../views/app/Inicio.vue")
    },
    {
        path: 'indicadores',
        component: () => import("../views/app/indicadores/Index.vue"),
        children: IndicadoresModules
    },
    {
        path: 'evaluar',
        component: () => import("../views/app/evaluation/Index.vue"),
        children: IndicadoresModules
    },
    {
        path: 'acuerdos',
        component: () => import("../views/app/acuerdos/Index.vue"),
        children: IndicadoresModules
    },
    {
        path: 'reportes',
        component: () => import("../views/app/Reportes.vue"),
        children: IndicadoresModules
    },
    {
        path: 'riesgo',
        component: () => import("../views/app/risk/Index.vue"),
    },
    {
        path: 'ose',
        component: () => import("../views/app/ose/Index.vue"),
    },
    {
        path: 'avances',
        component: () => import("../views/app/indicadores/Progress.vue"),
        children: IndicadoresModules
    },
    {
        path: 'checklist',
        component: () => import("../views/app/checklist/IndexChecklist.vue"),
    },
    {
        path: 'kpi',
        component: () => import("../views/app/kpi/Index.vue"),
    },
    {
        path: 'kpi-manager',
        component: () => import("../views/app/analysis/AnalysisIndex.vue"),
    },
    {
        path: 'kpi-analysis',
        component: () => import("../views/app/analysis/AnalysisIndex.vue"),
    },
    {
        path: 'feedback',
        component: () => import("../views/app/feedback/Init.vue"),
    },
    {
        path: 'indicadores-stereotype',
        component: () => import("../views/app/manager/Index.vue"),
    },
    /*{
        path: 'kpi-manager',
        component: () => import("../views/app/manager/operative/Index.vue"),
    },*/
    {
        path: 'ceo',
        component: () => import("../views/app/ceo/Index.vue"),
    },
    {
        path: 'map',
        component: () => import("../views/app/map/Index.vue"),
    },
    {
        path: 'env',
        component: () => import("../views/app/Entorno.vue"),
        children: IndicadoresModules
    },
    {
        path: 'configuraciones',
        component: () => import("../views/app/config/Index.vue"),
        //children: config
    },
    
    {
        path: 'configuraciones/usuario',
        component: () => import("../views/app/config/Users.vue"),
        //children: config
    },
    { path:'configuraciones/indicadores', component: ()=>import("../views/app/config/Kpi.vue")},
    {
        path: 'configuraciones/periodo',
        component: () => import("../views/app/config/Periodo.vue"),
        //children: config
    },
    
    {
        path: 'configuraciones/grupo',
        component: () => import("../views/app/config/Grupos.vue"),
        //children: config
    },
    {
        path: 'configuraciones/leadership',
        component: () => import("../views/app/config/Leadership.vue"),
        //children: config
    },
    {
        path: 'configuraciones/mail',
        component: () => import("../views/app/config/Email.vue")
    },
    {
        path: 'configuraciones/plan',
        component: () => import("../views/app/config/Plan.vue")
    },
    {
        path: 'configuraciones/stereotype',
        component: () => import("../views/app/config/Stereotype.vue")
    },
    {
        path: 'configuraciones/sector',
        component: () => import("../views/app/config/Sector.vue")
    },
    {
        path: 'configuraciones/integration',
        component: () => import("../views/app/config/Integration.vue")
    },
    {
        path: 'configuraciones/tipo-sector',
        component: () => import("../views/app/config/SectorType.vue")
    },
    {
        path: 'configuraciones/tipo-objetivo',
        component: () => import("../views/app/config/ObjectiveType.vue")
    },
    {
        path: 'configuraciones/load-data',
        component: () => import("../views/app/config/CalcularSector.vue")
    },
    {
        path: 'configuraciones/cal-objetivo',
        component: () => import("../views/app/config/Category.vue")
    },
    {
        path: 'configuraciones/cal-sector',
        component: () => import("../views/app/config/Grade.vue")
    },
    {
        path: 'configuraciones/admin-data',
        component: () => import("../views/app/indicadores/Admin.vue")
    },
    {
        path: 'configuraciones/block',
        component: () => import("../views/app/config/Block.vue")
    },
    {
        path: 'configuraciones/kpi-template',
        component: () => import("../views/app/config/KpiTemplate.vue")
    },
    {
        path: 'process',
        component: () => import("../views/app/process/Index.vue")
    },
    {
        path: 'epr',
        component: () => import("../views/app/epr/Index.vue")
    },
    {
        path: '*',
        component: () => import("../views/app/Inicio.vue")
    }
    
]